import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungSalzgitter() {
  return (
    <CityPageTemplate
      city="Salzgitter"
      slug="salzgitter"
      intro="Salzgitter als Industriestandort in Niedersachsen – wir helfen Dir, finanziell den nächsten Schritt zu machen."
      description="Unabhängige & digitale Finanzberatung für Salzgitter: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
